export default __webpack_public_path__ + "img/be7fd3c637878c8c6ab9f6d11bd1996a.png";